import * as React from 'react';
import './SidebarComponent.css';

import {t} from "react-multi-lang";
import {NavLink} from "react-router-dom";

import {IMainProps} from "../../containers/MainContainer";
import IRoute from "../../interfaces/IRoute";
import routeList from '../../routes';

class SidebarComponent extends React.PureComponent<IMainProps> {
    public render() {
        const routes = routeList()
            .filter((route: IRoute) => route.display)
            .map((route: IRoute) =>
                <NavLink key={route.name} to={route.url} className="w_sidebar_icon"
                         activeClassName="w_sidebar_icon_active">
                    {route.name}
                </NavLink>);

        return (
            <div className="w_sidebar_container col-3 col-lg-2 d-none d-md-block p-0">
                <div id="w_sidebar_logo" className="w_sidebar_icon w_sidebar_icon_active">{t('login.login')}</div>
                <div className="w_sidebar_icon w_sidebar_icon_active pr-0 w_project_name">
                    {t('login.project_name')}: {this.props.instanceID}
                </div>
                <div className="w_sidebar_separator"/>
                {routes}
            </div>
        );
    }
}

export default SidebarComponent;


// WEBPACK FOOTER //
// ./src/components/SidebarComponent/SidebarComponent.tsx